export default __webpack_public_path__ + "static/media/Efficient.efc285ca.webp";